"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOriginValid = exports.retrieveDomainsList = void 0;
var rest_1 = require("./rest");
var url_1 = require("./url");
var isDomainsListValid = function (data) {
    if (data.allDomainsAllowed === true) {
        return true;
    }
    else if (data.allDomainsAllowed === false && data.domainsNames !== null && Array.isArray(data.domainsNames)) {
        return true;
    }
    else {
        return false;
    }
};
var retrieveDomainsList = function (_a) {
    var domainsListPath = _a.domainsListPath, onSuccess = _a.onSuccess;
    if (domainsListPath == null) {
        console.error("relative domains list path param is not available");
        return;
    }
    domainsListPath = domainsListPath.replace(/\|/g, "/");
    if ((0, url_1.isAbsoluteUrl)(domainsListPath)) {
        console.error("relative domains list path param contains an absolute url");
        return;
    }
    var fullDomainsListPath = domainsListPath + "/domains-configuration.json";
    (0, rest_1.loadJson)({
        url: fullDomainsListPath,
        onSuccess: function (data) {
            if (isDomainsListValid(data)) {
                onSuccess(data);
            }
            else {
                console.error('domains list is in invalid format');
            }
        },
        onError: function (statusCode, statusMessage) {
            console.error("Failed to load the domains list from the specified path. status code: ".concat(statusCode, ", status message: ").concat(statusMessage));
        },
        tries: 3,
    });
};
exports.retrieveDomainsList = retrieveDomainsList;
var isOriginValid = function (origin, allowedDomainsList) {
    if (allowedDomainsList == null) {
        console.error("domains list not available, incoming message is ignored");
        return false;
    }
    else if (!allowedDomainsList.allDomainsAllowed) {
        var allowedDomains = __spreadArray(__spreadArray([], allowedDomainsList.domainsNames, true), [
            document.location.hostname,
        ], false);
        if (!(0, url_1.isAllowedDomain)(origin, allowedDomains)) {
            console.error("message origin domain is not allowed", origin, allowedDomains);
            return false;
        }
    }
    return true;
};
exports.isOriginValid = isOriginValid;
//# sourceMappingURL=domainsList.js.map